/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { Component } from 'react';

/**
 *
 * SignUp component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class SignUp extends Component {
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='static-page-container'>
          <div className='card-form'>
            <div className='card-body'>
              <form
                action='https://toysrus.us18.list-manage.com/subscribe/post?u=3a4d73525deaf11f8493f3713&amp;id=e064b777cc'
                method='post'
                id='mc-embedded-subscribe-form'
                name='mc-embedded-subscribe-form'
              >
                <div className='row'>
                  <div className='col-sm-6'>
                    <div className='form-group'>
                      <label className='form-control-label' htmlFor='FNAME'>
                        الاسم الأول
                      </label>
                      <input
                        type='text'
                        className='form-control first-name-input'
                        id='FNAME'
                        name='FNAME'
                      />
                    </div>
                  </div>
                  <div className='col-sm-6'>
                    <div className='form-group'>
                      <label className='form-control-label' htmlFor='PHONE'>
                        رقم الجوال
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        id='PHONE'
                        name='PHONE'
                      />
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <div className='form-group'>
                      <label className='form-control-label' htmlFor='EMAIL'>
                        البريد الإلكتروني
                      </label>
                      <input
                        type='email'
                        className='form-control required'
                        id='EMAIL'
                        name='EMAIL'
                      />
                    </div>
                  </div>
                </div>

                <div className='row contact-us-submnit'>
                  <div className='col-sm-6'>
                    <div className='form-group'>
                      <button
                        className='btn btn-block btn-primary subscribe-contact-us button-primary-tru-blu-curve'
                        type='submit'
                        name='submit'
                        value='submit'
                      >
                        إرسال
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default SignUp;
